"use client";

import { useStorage } from "../../useStorage";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { useGetLomdaV3 } from "./hooks/useGetLomdaV3";
import { LoaderCircle } from "lucide-react";
import LomdaV3SheetMain from "./components/main";
import LomdaV3SheetHeader from "./components/header/header";
import LomdaV3SheetAside from "./components/aside";

export default function LomdaV3Sheet() {
    const [open, setOpen, options] = useStorage((state) => [
        state.lomdaV3SheetOpen,
        state.setLomdaV3SheetOpen,
        state.lomdaV3Options,
    ]);

    const { isPending, data } = useGetLomdaV3(
        open && !!options.lomdaId && !!options.libraryId,
        options.lomdaId
    );
    const lomda = data?.data;

    return (
        <Sheet open={open} onOpenChange={(open) => setOpen(open)}>
            <SheetContent
                className="bg-muted !p-0 w-full sm:w-[80vw] sm:max-w-[1200px]"
                xClassName="sm:top-4 sm:-left-10 sm:flex sm:justify-center sm:items-center sm:rounded-full sm:bg-white sm:size-6"
            >
                {isPending || !lomda ? (
                    <div className="flex w-full h-full justify-center items-center">
                        <LoaderCircle className="size-6 animate-spin" />
                    </div>
                ) : (
                    <>
                        <LomdaV3SheetHeader lomda={lomda} />

                        <div className="flex overflow-y-auto h-[calc(100%-64px)] flex-col lg:flex-row">
                            <LomdaV3SheetAside lomda={lomda} />
                            <LomdaV3SheetMain lomda={lomda} />
                        </div>
                    </>
                )}
            </SheetContent>
        </Sheet>
    );
}
